import React from "react";

const DeviceImageItem = ({ device, isSelected, onClick, onImageError }) => {
  const [imageLoaded, setImageLoaded] = React.useState(false);
  const [imageError, setImageError] = React.useState(false);
  const [showPreview, setShowPreview] = React.useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
    setImageError(false);
  };

  const handleImageError = () => {
    setImageLoaded(false);
    setImageError(true);
    onImageError && onImageError(device._id);
  };

  const handleImageClick = (e) => {
    e.stopPropagation();
    setShowPreview(true);
  };

  const handlePreviewClose = () => {
    setShowPreview(false);
  };

  const imageSrc = `${process.env.REACT_APP_VIDEO_CALL_REQUEST + device.image}`;

  return (
    <>
      <div
        className={`device-image-item ${isSelected ? 'selected' : ''}`}
        onClick={onClick}
        tabIndex={0}
        role="button"
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onClick();
          }
        }}
      >
        <div>
          {!imageLoaded && !imageError && (
            <div className="device-image-loading"></div>
          )}

          {imageError ? (
            <div className="device-image-error" title={device.name}>
              <i className="mdi mdi-image-broken-variant"></i>
            </div>
          ) : (
            <img
              src={imageSrc}
              alt={device.name}
              className="device-image"
              onLoad={handleImageLoad}
              onError={handleImageError}
              onClick={handleImageClick}
              style={{ display: imageLoaded ? 'block' : 'none' }}
              title={`Click to preview ${device.name}`}
            />
          )}
        </div>
      </div>

      {/* Image Preview Modal */}
      {showPreview && (
        <div className="device-image-modal" onClick={handlePreviewClose}>
          <div className="device-image-modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="device-image-modal-close"
              onClick={handlePreviewClose}
              aria-label="Close preview"
            >
              ×
            </button>
            <img
              src={imageSrc}
              alt={device.name}
              onClick={handlePreviewClose}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default DeviceImageItem;
